import type { CSSProperties } from 'react'

const STAR_PATH =
  'M32.307 12.696a1.7 1.7 0 0 0-1.469-1.173l-9.264-.841-3.663-8.575a1.707 1.707 0 0 0-3.138.002l-3.663 8.573-9.266.841a1.71 1.71 0 0 0-1.467 1.173 1.7 1.7 0 0 0 .499 1.812l7.002 6.142-2.064 9.096a1.705 1.705 0 0 0 2.537 1.843l7.99-4.776 7.99 4.776a1.707 1.707 0 0 0 2.538-1.843l-2.065-9.096 7.003-6.14c.515-.451.711-1.163.5-1.814'

interface StarIconProps {
  fill: string
  size: number
  className?: string
  style?: CSSProperties
}

/** The one star glyph behind the rating display, the rating input and the
 *  summary's star breakdown. Decorative on its own — the group around it
 *  carries the accessible text. */
export const StarIcon = ({ fill, size, className, style }: StarIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 33 33"
    width={size}
    height={size}
    className={className}
    style={style}
    aria-hidden="true"
    focusable="false"
  >
    <path fill={fill} d={STAR_PATH} />
  </svg>
)
